import React, { useState} from 'react';
import { Box, Button } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import SortBy from './SortBy';
import PriceFilter from './PriceFilter';
import Brands from './Brands';

export default function Filter({onSortBy, onPriceRange, onBrandFilter}) {
    const filters = ['Sort By', 'Price', 'By Brand'];
    const [isSortByOpen, setIsSortByOpen] = useState(false);
    const [isPriceFilterOpen, setIsPriceFilterOpen] = useState(false);
    const [isBrandFilterOpen, setIsBrandFilterOpen] = useState(false);

    const openDialog = (filter) => {
        if (filter === 'Sort By') {
            setIsSortByOpen(true);
        } else if (filter === 'Price') {
            setIsPriceFilterOpen(true);
        } else if (filter === 'By Brand') {
            setIsBrandFilterOpen(true);
        } else if (filter === 'Ratings') {
            // Handle ratings filter logic here
        }
    }

    return (
        <>
            <Box
                sx={{
                    overflowX: 'auto', // Allows horizontal scrolling
                    display: 'flex',
                    gap: 1, // Adds spacing between buttons
                    px: 1, // Adds horizontal padding
                    py: 1, // Adds vertical padding
                    justifyContent: 'center', // Adds left margin
                    whiteSpace: 'nowrap', // Prevents text wrapping
                }}
                >
                {filters.map((filter, index) => (
                    <Button
                    key={index}
                    variant="outlined"
                    endIcon={<KeyboardArrowDownIcon
                        sx={{
                            marginLeft: '-10px', // Reduces the space between the text and the icon
                          }}
                        />}
                    onClick={() => openDialog(filter)}
                    sx={{
                        borderRadius: 20, // Rounded edges
                        textTransform: 'none', // Prevents uppercase text
                        flexShrink: 0, // Prevents buttons from shrinking
                        borderColor: 'gray', // Black border
                        color: 'black', // Black text
                        fontSize: '0.8rem',
                        padding: '4px 12px',
                        height: 32, // Consistent height
                        '&:hover': {
                          borderColor: 'black', // Keeps the border black on hover
                          backgroundColor: 'rgba(0, 0, 0, 0.04)', // Light hover effect
                        }
                    }}
                    >
                    {filter}
                    </Button>
                ))}
            </Box>

            <SortBy open={isSortByOpen} onClose={() => setIsSortByOpen(false)}  onSortBy={onSortBy} />
            <PriceFilter open={isPriceFilterOpen} onClose={() => setIsPriceFilterOpen(false)} onPriceRange={onPriceRange} />
            <Brands open={isBrandFilterOpen} onClose={() => setIsBrandFilterOpen(false)} onBrandFilter={onBrandFilter} />
        </>
    )
}